import React, { useEffect, useMemo } from 'react';
import cn from 'classnames';
import styles from './Sidebar.module.scss';
import Occasion from '@repo/utils/helpers/Occasion';
import { ReadOnlyTextEditorContent } from '@repo/components/text-editor';
import { ReminderBadgeIcon } from '@repo/icons/Reminder';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNote, selectNote } from '@repo/redux/actions/notes';

export interface ReminderPreviewProps {
  content: string;
  date: Occasion;
  id: string;
  contactID: string;
}

export default function ReminderPreview({
  reminder: { content: contentFromActivityItem, date: dateFromActivityItem, id, contactID },
}: {
  reminder: ReminderPreviewProps;
}) {
  const dispatch = useDispatch();
  const storedNote = useSelector(selectNote(String(id)));
  const date = storedNote?.reminder?.date || dateFromActivityItem;
  const content = storedNote?.content || contentFromActivityItem;
  const paddedDate = useMemo(() => new Occasion(date.addDays(1)), []);
  const noteIsEmpty = storedNote?.content.trim() === '';

  let day = date.format('MMM d');

  if (date.isToday) {
    day = 'Today';
  } else if (date.isYesterday) {
    day = 'Yesterday';
  }

  useEffect(() => {
    if (!storedNote) {
      dispatch(fetchNote(contactID, id));
    }
  }, [id]);

  return (
    <div className={cn(styles.reminderContentWrapper, noteIsEmpty && styles.emptyNote)}>
      <div className={styles.reminderHeader}>
        <ReminderBadgeIcon date={paddedDate} />
        {day} &bull; {date.format('h:mm a')}
      </div>
      <div className={styles.reminderContent}>
        <ReadOnlyTextEditorContent value={content} followupOccasion={date} clickableMentions />
      </div>
    </div>
  );
}
